import React from 'react';
import ReactDOM from 'react-dom';
import { MsalApp, defaultTheme } from './lib';

ReactDOM.render(
    React.createElement(MsalApp, { theme: defaultTheme }, null),
    document.getElementById('root')
);
